export default "__VITE_ASSET__D0Zdx3m6__"